/// <reference types="@angular/localize" />

import { enableProdMode, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { bootstrapApplication } from '@angular/platform-browser';



if (environment.production) {
  enableProdMode();
  if (window) {
    window.console.log = function() {};
    window.console.table = function() {};
  }
}

bootstrapApplication(AppComponent,appConfig ).then(() => {
  if ('serviceWorker' in navigator && environment.enableServiceWorker) {
    navigator.serviceWorker.register('/ngsw-worker.js');
  }
}).catch(err => console.log(err));

